export default __webpack_public_path__ + "static/media/intelligence.3d85849d.png";